"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyScript = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var StickyScript = function (props) {
    var children = props.children;
    var stickyRef = (0, react_1.useRef)(null);
    var stickyWrapperRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(''), elWidth = _a[0], setElWidth = _a[1];
    var _b = (0, react_1.useState)(''), elHeight = _b[0], setElHeight = _b[1];
    var _c = (0, react_1.useState)(''), elClass = _c[0], setElClass = _c[1];
    var _d = (0, react_1.useState)(''), wrapClass = _d[0], setWrapClass = _d[1];
    (0, react_1.useLayoutEffect)(function () {
        var _a, _b;
        setElHeight(((_b = (_a = stickyRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height) + "px");
        var scrollHandler = function () {
            var _a, _b;
            var stickyWrapperBoundingClientRect = (_a = stickyWrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            var stickyBoundingClientRect = (_b = stickyRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            var stickyWrapperTop = stickyWrapperBoundingClientRect === null || stickyWrapperBoundingClientRect === void 0 ? void 0 : stickyWrapperBoundingClientRect.top;
            setElWidth((stickyWrapperBoundingClientRect === null || stickyWrapperBoundingClientRect === void 0 ? void 0 : stickyWrapperBoundingClientRect.width) + "px");
            setElHeight((stickyBoundingClientRect === null || stickyBoundingClientRect === void 0 ? void 0 : stickyBoundingClientRect.height) + "px");
            if (stickyBoundingClientRect && (stickyBoundingClientRect === null || stickyBoundingClientRect === void 0 ? void 0 : stickyBoundingClientRect.top) < 1 && stickyWrapperTop && stickyWrapperTop < 1) {
                setElClass(' stick');
                setWrapClass(' stick-wrapper');
            }
            else {
                setElClass('');
                setWrapClass('');
            }
        };
        window.addEventListener('scroll', scrollHandler);
        window.addEventListener('resize', scrollHandler);
        return function () {
            window.removeEventListener('scroll', scrollHandler);
            window.removeEventListener('resize', scrollHandler);
        };
    }, []);
    return (React.createElement("div", { ref: stickyWrapperRef, className: "sticky-wrapper" + wrapClass, style: { height: elHeight } },
        React.createElement("div", { ref: stickyRef, className: "sticky" + elClass, style: { width: elWidth } }, children)));
};
exports.StickyScript = StickyScript;
exports.StickyScript.propTypes = {
    children: PropTypes.element.isRequired,
};
